import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOMeta from '@/components/feature/SEOMeta';
import JsonLd from '@/components/feature/JsonLd';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategorySection from './components/CategorySection';
import ArticlesSection from './components/ArticlesSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '爱液视频App官网 - 海量高清视频内容平台',
  description: '爱液视频App官方下载与使用指南，提供海量高清视频资源、流畅播放体验与个性化内容推荐。',
  url: 'https://aiyeshipin.com/',
  isPartOf: {
    '@type': 'WebSite',
    name: '爱液视频',
    url: 'https://aiyeshipin.com',
  },
  about: {
    '@type': 'SoftwareApplication',
    name: '爱液视频',
    applicationCategory: 'EntertainmentApplication',
    operatingSystem: 'Android, iOS',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'CNY',
    },
  },
};

export default function Home() {
  return (
    <>
      <SEOMeta
        title="爱液视频app官方下载 - 海量高清视频资源，流畅播放体验 | 爱液视频"
        description="爱液视频app是一款备受用户喜爱的视频内容平台，提供海量高清视频资源、流畅播放体验与个性化内容推荐。官方下载、安装教程、使用技巧一应俱全，助您快速上手享受优质视频娱乐体验。"
        keywords="爱液视频app,爱液视频app下载,爱液视频app官方版,爱液视频app最新版,爱液视频app安装教程,爱液视频app使用技巧,爱液视频app功能介绍"
        canonicalUrl="https://aiyeshipin.com/"
      />
      <JsonLd data={homeJsonLd} />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CategorySection />
        <ArticlesSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}